import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fallback',
  standalone: false
})
export class FallbackPipe implements PipeTransform {
  transform<T>(value: T | null | undefined, fallback: T): T {
    return value || fallback;
  }
}
